import { Button, Result } from "antd";
import { NOTICE_TEXT, USED_UP } from "./portalNotice";

// DASH-262: "plan used up" and "voucher in use on another device" screens.
// onBuy is only offered for a used-up plan.
const PortalNotice = ({ kind, onBuy, onOtherVoucher }) => (
  <div className="loginBox">
    <Result
      status="warning"
      title={NOTICE_TEXT[kind]}
      extra={[
        kind === USED_UP && onBuy ? (
          <Button block="true" type="primary" key="buy" onClick={onBuy}>
            Buy a new plan
          </Button>
        ) : null,
        <Button block="true" key="other" style={{ marginTop: 10 }} onClick={onOtherVoucher}>
          Use another voucher
        </Button>,
      ].filter(Boolean)}
    />
  </div>
);

export default PortalNotice;
